export default __webpack_public_path__ + "static/jumbo-m1-bg-bef9dda21278f1fd7e05bf72c54475f0.png";